import { type TrackedEvents } from './track';

type CheckInOnceEvent =
  | TrackedEvents.CheckInModalLoaded
  | TrackedEvents.CheckInStarted;

type TrackFn = (
  event: TrackedEvents,
  data: Record<string, unknown>,
) => Promise<void>;

const trackedKeys = new Set<string>();

const toKey = (event: CheckInOnceEvent, roomId: string): string =>
  `${event}:${roomId}`;

/**
 * Fires a check-in analytics event at most once per room while the patient
 * remains on the check-in page. Later calls for the same event and room are
 * ignored. Dedup state is cleared on patient checkout.
 */
export const trackCheckInEventOnce = (
  event: CheckInOnceEvent,
  roomId: string,
  properties: Record<string, unknown>,
  track: TrackFn,
): void => {
  const key = toKey(event, roomId);
  if (trackedKeys.has(key)) {
    return;
  }
  trackedKeys.add(key);
  void track(event, properties);
};

/** Clears dedup state on patient checkout. */
export const resetCheckInEventTracking = (): void => {
  trackedKeys.clear();
};
